import Vue from 'vue'
import Api from '@/services/Api'

const state = {
  /**
   * @type {Object.<string,Ticket>}
   */
  tickets: {},
  orderData: {}
}

const getters = {
  tickets: state => state.tickets,
  getTicketsFor: state => roundId => state.tickets[roundId] || [],
  numberOfTickets: state => Object.values(state.tickets).flat(1).length,
  hasTickets: (state, getters) => getters.numberOfTickets > 0,
  getPriceForAddedTicketsInRound: (state, getters, rootState, rootGetters) => roundId => {
    return getters.getTicketsFor(roundId).length * rootGetters['rounds/priceForRound'](roundId)
  },
  getTotalPrice (state, getters) {
    return Object.keys(getters.tickets).reduce((total, roundId) => {
      return total + getters.getPriceForAddedTicketsInRound(roundId)
    }, 0)
  },
  hasOrderData: state => Object.keys(state.orderData).length > 0
}

const mutations = {
  STORE_TICKETS (state, { roundId, tickets }) {
    Vue.set(state.tickets, roundId, tickets)
  },
  REMOVE_TICKET (state, { roundId, ticketId }) {
    state.tickets[roundId] = state.tickets[roundId].filter((ticket) => ticket.id !== ticketId
    )
  },
  CLEAR_TICKETS (state) {
    state.tickets = {}
  },
  STORE_ORDER_DATA (state, value) {
    state.orderData = value
  }
}

const actions = {
  storeTickets ({ commit }, { roundId, tickets }) {
    commit('STORE_TICKETS', { roundId, tickets })
  },
  addTickets ({ commit, getters }, { roundId, tickets }) {
    tickets = [
      ...getters.getTicketsFor(roundId),
      ...tickets
    ]
    commit('STORE_TICKETS', { roundId, tickets })
  },
  removeTicket ({ commit }, { roundId, ticketId }) {
    commit('REMOVE_TICKET', { roundId, ticketId })
  },
  emptyCart ({ commit }) {
    commit('CLEAR_TICKETS')
  },
  finishCheckout ({ state, getters, commit }, payload) {
    if (!getters.hasTickets) return
    const [roundId, tickets] = Object.entries(state.tickets)[0]

    return Api.postData(`/checkout/${roundId}`, {
      ...payload,
      tickets
    })
      .then((response) => {
        commit('CLEAR_TICKETS')
        commit('STORE_ORDER_DATA', response)
        return response
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
